export default {"src":"/_next/static/media/shop-title.be64b05b.svg","height":77,"width":266};